import api from './client';

export const expenseApi = {
  list:           (params?: any) => api.get('/expenses', { params }),
  create:         (data: any)    => api.post('/expenses', data),
  approve:        (id: number)   => api.post(`/expenses/${id}/approve`),
  reject:         (id: number, reason: string) => api.post(`/expenses/${id}/reject`, { reason }),
  categories:     ()             => api.get('/expense-categories'),
  replenish:      (data: any)    => api.post('/petty-cash/replenish', data),
  recurring:      ()             => api.get('/recurring-expenses'),
  saveRecurring:  (data: any)    => api.post('/recurring-expenses', data),
  postRecurring:  (id: number, data: any) => api.post(`/recurring-expenses/${id}/post`, data),
  stopRecurring:  (id: number)   => api.delete(`/recurring-expenses/${id}`),
  limits:         ()             => api.get('/expense-limits'),
  setLimits:      (data: any)    => api.post('/expense-limits', data),
};
